import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'orderStatus',
    standalone: false
})
export class OrderStatusPipe implements PipeTransform {

  transform(value?: number, isClass: boolean = false): string {
    switch (value) {
      case 1:
        return isClass ? 'warning' : 'Создан';
      case 2:
        return isClass ? 'info' : 'Впроцессе';
      case 3:
        return isClass ? 'success' : 'Готов';
      case 4:
        return isClass ? 'danger' : 'Отменен';
      case 5:
        return isClass ? 'default' : 'Закрыт';
      default:
        return '';
    }
  }

}
